import type { IAssetSummary } from '../../api/fetchMaintenance';
import type { Asset } from '../../models/asset';

export type MaintenanceStatus = 'atrasada' | 'manut' | 'agendada' | 'agendar';

export type TileKey = 'agendar' | 'atrasada' | 'agendada' | 'manut' | 'conn1' | 'conn0' | 'vt1' | 'vt0';

export type SearchField = 'all' | 'placa' | 'chassi' | 'conta' | 'grupo' | 'nome';

export type WarrantyFilter = '' | 'in' | 'out';

export type SortKey =
    | 'status'
    | 'prox'
    | 'placa'
    | 'conta'
    | 'ult'
    | 'odo'
    | 'garantia'
    | 'camp'
    | 'hor'
    | 'grupo'
    | 'conexao';

export type ColumnKey =
    | 'veic'
    | 'conta'
    | 'prox'
    | 'ult'
    | 'odo'
    | 'gar'
    | 'svc'
    | 'camp'
    | 'hor'
    | 'grupo'
    | 'conexao'
    | 'acao';

const STALE_ODOMETER_DAYS = 30;

export const VEHICLE_TYPES = ['truck', 'bus', 'van', 'trailer', 'car'] as const;

export const MAINTENANCE_GROUP_VALUES = ['1', '2', '3', '4'] as const;

export const MARKETPLACE_URL = 'https://latam-marketplace.rio.cloud/customerCenter/services';

const STATUS_PRIORITY: Record<MaintenanceStatus, number> = { atrasada: 0, manut: 1, agendada: 2, agendar: 3 };

export const getStatusPriority = (status?: MaintenanceStatus) => (status ? STATUS_PRIORITY[status] : 9);

const CRITICAL_LAMPS = ['RED', 'PROTECTED'];

export const isCriticalAlert = (alert: Record<string, unknown>) =>
    CRITICAL_LAMPS.includes(String(alert?.lampStatus ?? ''));

const daysSince = (date?: Date) =>
    date ? Math.max(0, Math.floor((Date.now() - new Date(date).getTime()) / 86400000)) : undefined;

export const isSchedulable = (status?: MaintenanceStatus) => status === 'agendar' || status === 'atrasada';

export const getMetricAge = (key: 'odometer' | 'hourmeter', date?: Date) => {
    const days = daysSince(date);
    return { days, stale: key === 'odometer' && days !== undefined && days > STALE_ODOMETER_DAYS };
};

export const toAssetSummaries = (assets: Asset[]): IAssetSummary[] =>
    assets.map(asset => ({ id: asset.id, identification: asset.chassis, name: asset.name ?? '' }));
